import $ from "jquery";
import { u_ } from "@pressmedia/webappbase";

/**
 * for LTE IE9
 * FormDataを使用できない古いブラウザ向けの送信関数
 * @param {String} method: called method name
 * @param {Object} [opt]: request setting
 * @param {Function} [cb]: callback function (@arg1: err, @arg2: responce)
 * @return {Promise}
 */
function aSubmitLegacy(method, opt, cb) {
	const def = {
		url: this.ACTION_URL,
		type: "GET",
		timeout: this.config.ajaxTimeoutTime
	};
	
	if( u_.isObject(opt) ) {
		opt = Object.assign(def, opt);
	} else {
		opt = def;
	}
	
	u_.isFunction(cb) || (cb = function() {});
	
	const df = $.Deferred();
	
	if(!opt.url) {
		const err = {
			code: NaN,
			messages: ["'url' is not defined."],
			method: method
		};
		return $.when( cb(err) ).always( df.reject.bind(df, err) );
	}
	
	if(!this._$sFrame) {
		// 初回はiframeを生成
		this._$sFrame = $("<iframe/>").attr({
			name: "suspectFrame_" + Date.now()
		}).css({
			border: "none",
			height: 0,
			width: 0
		}).insertAfter(this.$self);
		
		this.$self.attr({
			target: this._$sFrame.attr("name"),
			dataType: "text"
		}).append(
			$("<input/>").attr({
				type: "hidden",
				name: "contentType",
				value: "text"
			}).addClass("inp-contentType")
		);
		
		this._$method = $("<input/>").attr({
			type: "hidden",
			name: "method"
		}).addClass("inp-method").appendTo(this.$self);
	}
	
	$.Deferred(d => {
		this._$sFrame.on("load.suspect", e => {
			this._$sFrame.off(".suspect");
			clearTimeout(this._suspectTimer);
			
			const txt = this._$sFrame.contents().find("body").html();
			
			try {
				d.resolve(!!txt ? JSON.parse(txt) : null);
			} catch(e) {
				const $areaErrMsg = $("div").addClass("errmsg");
				const res = {};
				Object.keys(e).forEach(k => {
					res[k] = e[k];
					$("<p/>").text(k + ": " + e[k]).appendTo($areaErrMsg);
				});
				res.responsText = txt;
				$areaErrMsg.append(
					$("<p/>").text("responsText: " + txt)
				).appendTo("body");
				d.reject(res, "", {});
			}
		});
		
		this._suspectTimer = setTimeout(() => {
			this._$sFrame.off(".suspect");
			d.reject({
				responseText: "Request Time-out",
				status: 408,
			}, "", {message: "タイムアウトしました"});
		}, opt.timeout);
		
		this._$method.val(opt.type);
		
		this.$self.attr({
			action: opt.url,
			method: (opt.type === "GET") ? opt.type : "POST"
		}).trigger("submit", [true]);
		
		return d.promise();
	}).then(res => {
		// success
		return $.when( cb(null, res) ).then( df.resolve.bind(df, res), df.reject.bind(df) );
	}, (function() {
		// error
		const args = u_.getAsArray(arguments);
		args.unshift(method);
		
		const err = this.ajaxErrorCallback.apply(this, args) || args[1].responseText || true;
		return $.when( cb(err) ).always( df.reject.bind(df, err) );
	}).bind(this));
	
	return df.promise();
}

export default aSubmitLegacy;
